import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { ToastContainer, toast } from 'react-toastify';

import FolderViewApp from '../../FolderView/startup/FolderViewApp';

const GlobalAssetCenter = ({
  csrfToken,
  currentUser,
  team,
  folder,
  folderChanged,
  guestTeamMemberships,
  promotersWithPermission,
  searchTerm,
  searchTermChanged,
  teamRootFolder
}) => {
  return (
    <div className="position-relative">
      <ToastContainer icon={false} />
      <div className="row" style={{"marginTop": "12px"}}>
        <div className="col-12">
          <div className="assets-tab">
            <FolderViewApp csrfToken={csrfToken}
                                folder={folder}
                                teamRootFolder={teamRootFolder}
                                onFolderChanged={folderChanged}
                                currentUser={{...currentUser}}
                                confirm={{}}
                                searchTerm={searchTerm}
                                guestTeamMemberships={guestTeamMemberships}
                                promotersWithPermission={promotersWithPermission}
                                headerComponent={
                                  () => (
                                    <span>&nbsp;</span>
                                  )
                                }
                                team={team} />
          </div>
        </div>
      </div>
    </div>
  )
};

GlobalAssetCenter.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  currentUser: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  folder: PropTypes.object,
  folderChanged: PropTypes.func.isRequired,
  guestTeamMemberships: PropTypes.array,
  promotersWithPermission: PropTypes.array,
  searchTerm: PropTypes.string,
  searchTermChanged: PropTypes.func.isRequired,
  teamRootFolder: PropTypes.object.isRequired
};

export default GlobalAssetCenter;
